import { SxProps, Theme } from '@mui/material/styles';
import colors from '../../../../lib/styles/colors';
import { columnFlex } from '../../../../lib/styles/commonStyles';

export const smallBoxSx = {
  ...columnFlex,
  width: '100%',
  padding: '16px',
};

export const titleBoxSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '24px',
};

// TODO: Use Typography variant from UI Kit after UI Kit is integrated
export const titleSx = {
  fontSize: '16px',
  fontWeight: 600,
};

export const starIconButtonSx: SxProps<Theme> = (theme: Theme) => ({
  color: '#D68037',
  width: '24px',
  height: '24px',
  '&:focus': {
    border: `1px solid ${theme.palette.primary.main}`,
  },
});

export const starBorder: SxProps<Theme> = (theme: Theme) => ({ color: theme.palette.action.active });

export const descriptionSx = {
  fontSize: '16px',
  fontWeight: 400,
  height: '47px',
};

export const cardSx: SxProps<Theme> = (theme: Theme) => ({
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? colors.reportCardHover.dark : colors.reportCardHover.light,
  },
  boxShadow: '0px 0px 0px 1px rgba(12, 26, 75, 0.03), 0px 3px 4px 0px rgba(50, 50, 71, 0.05)',
  minHeight: '106px',
  maxWidth: '656px',
  minWidth: '320px',
  borderRadius: '8px',
  flexDirection: 'row',
  display: 'flex',
});

export const cardAction: SxProps<Theme> = (theme: Theme) => ({
  '&.MuiButtonBase-root': {
    '&:focus': {
      border: `2px solid ${theme.palette.secondary.main}`,
      backgroundColor: theme.palette.mode === 'dark' ? colors.reportCardHover.dark : colors.reportCardHover.light,
    },
  },
  '&.Mui-focusVisible .MuiCardActionArea-focusHighlight': {
    opacity: 0,
  },
  '&.MuiCardActionArea-root:hover .MuiCardActionArea-focusHighlight': {
    opacity: 0,
  },
});
